import { useState,useEffect } from 'react';
import  styles from './style.module.css';
import NaviButton from '../../compoenets/NaviButton';
import useApi from '../../services/useApi';
import { useRecoilState} from 'recoil';
import { newTaskConfig, namespaceState } from '../../recoil/atoms';
import ModelList from './ModelList';
import DataList from './DataList';

export default function NewTaskData() {
  const [taskConfig,setTaskConfig] = useRecoilState(newTaskConfig);
  const [nsState,] = useRecoilState(namespaceState);

  const [requiredItemToggle,setRequiredItemToggle] = useState(0);
  const [modelItemToggle,setModelItemToggle] = useState(-1);
  const [modelList,setModelList]=useState([]);
  const [listUpdate,setListUpdate]=useState(false);

  const handleDataSelected = (requiredName,selected) => {
    const updatedRequiredData=(selected===-1?"":requiredName);
    setTaskConfig((prevData) => ({
      ...prevData,
      requiredData: updatedRequiredData,
    }));

    if(selected===-1){
      setModelList([]);
      setRequiredItemToggle(0);
    }
    else{
      refreshModelList(updatedRequiredData);
      setRequiredItemToggle(1);
    }
    setModelItemToggle(-1);
    if(selected) handleModelItem(-1,"",-1)
  }

  const refreshModelList=(updatedRequiredData=null)=>{
    useApi.get('ngp/modelreg/mm/model/v1/modellist?namespaceId=' + nsState.id + "&dataset="+(updatedRequiredData?updatedRequiredData:taskConfig.requiredData)).then((res)=>{
      setModelList(res.data);
    })
  }

  const handleModelItem = (index,name,id) => {
    setTaskConfig((prevData) => ({
      ...prevData,
      initialModelId:modelItemToggle===id?"":id,
      initialModelName:modelItemToggle===id?"":name,
    }));
    if(modelItemToggle===id) setModelItemToggle(-1);
    else setModelItemToggle(id);

    //modelRegistry
    // const newParamsCustom = components.reduce((obj,item)=>{
    //   obj["threshold"]={value:"1.0",required:true}
    //   return obj;
    // },{});
  }

  useEffect(()=>{
    if(listUpdate){
      setTimeout(() => {
       setListUpdate(false); 
      }, 500);
    };
  })

  const handleNext=()=>{
    let rejectText="";
    if(taskConfig.requiredData==="")rejectText+="- Required Data\n"
    if(taskConfig.initialModelName==="")rejectText+="- Model"

    if(rejectText==="") return true;
    else { 
      alert("다음 화면으로 진행 할 수 없습니다. 내용을 확인해 주세요.\n"+rejectText);
      return false;
    }
  }

  return (
    <>
      <div className={styles["NewTaskData-wrap"]}>
        <div className={styles["NewTaskData-header"]}>
          <span>New Task<p>&gt;</p> Data Setting</span>
          <div className={styles["header-btn-wrap"]}>
            <NaviButton 
            to="/new-task-device" 
            className={`${styles["header-btn"]} ${styles["header-btn-next"]}`} 
            handleBtn={handleNext}>
              Next
            </NaviButton>
          </div>
        </div>
        <div className={styles["NewTaskData-body"]}>
          <DataList
          handleDataSelected={handleDataSelected}
          />
          <ModelList
          modelList={modelList}
          modelItemToggle={modelItemToggle}
          requiredItemToggle={requiredItemToggle}
          handleModelItem={handleModelItem}
          refreshModelList={refreshModelList}
          />
        </div>
      </div>
      </>
  );
}